import React, {useState, useEffect} from 'react';
import {useLocation} from "react-router-dom";
import 'react-tabs/style/react-tabs.css';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import SettingsTab from './tabs/settings/SettingsTab';
import BondTab from './tabs/bondsettings/BondTab';
import ResultTab from './tabs/results/ResultTab';
import { apiGetCall, apiPostCall, saveFile } from 'components/special/apiCall';
import "./Calculator.css";
import AllocateTab from './tabs/allocateresults/AllocateTab';
import CalculatorTerm from './CalculatorTerm';
import InputDropDownList from 'components/input/InputDropDownList';
import { useErrorContext } from 'components/messages/ErrorBox';
import { usePageLoadingContext } from './../components/messages/PageLoading';
import { useLocale } from './../components/special/LanguageProvider';
import InputText from 'components/input/InputText';
import Button from './../shared/jsx/elements/buttons/Button';


const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;


const getRowColor = (item) => {
  switch(item.itemType){
    case 1: //Höfuðstóll
      return "highlight-calc-capital";
    case 2: //Samningsvextir
      return "highlight-calc-contractinterest";
    case 3: //Dráttavextir
      return "highlight-calc-penaltyinterest";
    case 4: //Vaskur
      return "highlight-calc-vat";
    case 5: //Fjármagnstekjuskattur
      return "highlight-calc-capitalgainstax";
    case 6: //Höfuðstólsfæra
      return "highlight-calc-capitalizeinterests";
    case 7: //Innheimtulaun
      return "highlight-calc-collectionfee";
    case 8: //Kostnaður
      return "highlight-calc-cost";
    case 9: //Innborgun
      return "highlight-calc-payment";
    case 10: //FTS til greiðslu.
      return "highlight-calc-paidcapitalgainstax";
    case 12: //Vísitala
      return "highlight-calc-index";
    case 11: //Summary
      return "highlight-calc-middlesummary";
    case 13: //Summary
      return "highlight-calc-totalsummary";
     default:
      return "highlight-calc-unknown";
  }  
};

const getColor = (transactionNumber) =>  {
  let start   = 10000001;
  start = start - (100000 * Number(transactionNumber));
  let color = '#' + start.toString(16);
  return color;
};

const findKey = (transactionKey, transactionKeyTable) => {
  for (let i = 0; i < transactionKeyTable.length; i++) {
    if (transactionKeyTable[i].key === transactionKey){
      return transactionKeyTable[i];
    }
  }
  return null;
};

const postProcessResult = (calculationResult, setting) => {

  let startTime = new Date();

  for (let p = 0; p < calculationResult.payments.length; p++) {
    let payment = calculationResult.payments[p];
    payment.total = payment.amount + payment.lawyerAmount;
  }

  for(let j = 0; j < calculationResult.creditorLines.length; j++)
  {
    let line = calculationResult.creditorLines[j];
    //Prepare the line.
    line.rowDetail = {
      rowColor : getRowColor(line),
      boxColor :  getColor(line.transactionNumber),
    };
    if ([1,7,8,9].indexOf(line.itemType) > -1) {
      line.transactionKeyDetail = findKey(line.transactionKey, setting.transactionKeyTable);
    }

    //Prepare the payment boxes.
    for (let i = 0; i < line.paymentLines.length; i++) {
      let paymentLine = line.paymentLines[i];
      paymentLine.tagDetail = {
        text : paymentLine.paymentOrder.toString(),
        color : getColor(paymentLine.transactionNumber)
        //toolTip :  vm.$filter('number')(paymentLine.amount,2)
      };
    }
  }

  // console.debug("Process lawyerLines");
  for(let j = 0; j < calculationResult.lawyerLines.length; j++) {
    let line = calculationResult.lawyerLines[j];

    //Prepare the line.
    line.rowDetail = {
      rowColor : getRowColor(line),
      boxColor :  getColor(line.transactionNumber),
    };

    if ([1,7,8,9].indexOf(line.itemType) > -1){
      line.transactionKeyDetail = findKey(line.transactionKey, setting.transactionKeyTable);
    }

    //Prepare the payment boxes.
    for (let i = 0; i < line.paymentLines.length; i++) {
      let paymentLine = line.paymentLines[i];
      paymentLine.tagDetail = {
        text : paymentLine.paymentOrder.toString(),
        color : getColor(paymentLine.transactionNumber)
        // toolTip : vm.$filter('number')(paymentLine.amount,2)
      };
    }

  }

  let endTime = new Date();
  let timeDiff = endTime - startTime;
  let ms = Math.round(timeDiff);
  console.debug("process tok: ", ms + " ms");
  return calculationResult;
};




export const CalculatorDebug = ()  => { 
    
  const [mainTabSelected, setMainTabSelected] = useState(0); 
    const [showClaimList, setShowClaimList] = useState(true);
    const [calculationState, setCalculationState] = useState({claimID:null, package:null, result:null});
    const [claimList, setClaimList] = useState([]);
    const query = new URLSearchParams(useLocation().search);
    
    const setCheckErrorItems = useErrorContext();
    const setIsPageLoading = usePageLoadingContext();
    const { t } = useLocale();


    const isResultOk = (obj) => {
        if ((obj != null) && (obj.error != undefined)){
            setCheckErrorItems([obj]);
            return null;
        }
        return obj;
    }




    useEffect(() => {        
      console.log("ClaimID", query.get("claimid"));
      console.log("ClaimNumber", query.get("claimnumber"));
      let claimID = query.get("claimid");
      if (claimID !== undefined && claimID > 0){
        setShowClaimList(false);
        loadClaimByClaimID(claimID);
      }
      // else
      // {
      //   apiGetCall(BASE_URL + '/claim/list/claim').then(res =>{
      //       setClaimList(res);
      //   });     
      // }      
    }, []);


    const exportCalculationData = async () => {
      setIsPageLoading(true);
      console.log("Claim to be exported", calculationState);
      const packageRes = await apiGetCall(BASE_URL + '/claim/calculate/package/'+ calculationState.claimID);
      if (isResultOk(packageRes)){
         let data = Buffer.from(packageRes.packageData).toString("base64");
          saveFile(data, "test.json", "application/json");
      }
      setIsPageLoading(false);
  }
  
    const loadClaimByClaimID = async (claimID) =>{
      setIsPageLoading(true);
      let calcState = {claimID: claimID, package:null, result:null};
        const packageRes = await apiGetCall(BASE_URL + '/claim/calculate/package/'+claimID);
        if (isResultOk(packageRes)){
          console.log("packagesRes", packageRes);
          try{
            calcState.package = JSON.parseWithDate(packageRes.packageData);                        
             //Calc the package                
            const calcRes = await apiPostCall(BASE_URL + '/claim/calculate/package', calcState.package);
            if (isResultOk(calcRes)){                        
              calcState.result = postProcessResult(calcRes.result, calcRes.setting );
              setCalculationState(calcState);
            }
          }
          catch(err){
              //Error parsing the package data. 
              console.log("Could not parse calculation package."); 
          }         
        }            
      setIsPageLoading(false);
    }

    const onCalculationClick = async (value) => {
      setIsPageLoading(true);
      console.log("onCalculationClick", value, calculationState);      
      calculationState.package.calculateTo = value.calculateTo;
      calculationState.package.principalTo = value.principalTo;
      if (calculationState.package.isBond){
      calculationState.package.bond.calledIn = value.calledIn;
      }
      
      const calcRes = await apiPostCall(BASE_URL + '/claim/calculate/package', calculationState.package);            
      if (isResultOk(calcRes)){                        
        calculationState.result = postProcessResult(calcRes.result, calcRes.setting );
        setCalculationState(calculationState);
      }

      setIsPageLoading(false);
    }

    function onClaimNumberChange(value){
        console.log("Selected claimID", value);
        if (value != null && value > 0){
          loadClaimByClaimID(value);
        }
        else{
          setCalculationState({claimID:null, package:null, result:null});
        }
    }

  return (
    <div>
      <div className="grid tight collapse480">
          <div className="col s6of12">
              <h1 className="text-red text-32">Reiknivél</h1>
          </div>
      </div>     

      <div className="grid">        

          {showClaimList && <div className="table-wrap">
              <table className="table advanced hover">
                  <colgroup>
                      <col />
                      <col />
                  </colgroup>
                  <tbody>                      
                      <tr>
                          <th className="text-left">Kröfunúmer</th>
                          <td className="no-padding">
                          <div className="form">
                              {/* <InputDropDownList
                                name="ClaimNumberDropDown"
                                list={claimList}
                                keyField="itemID"
                                displayField = "name"     
                                defaultValue = {calculationState.claimID}           
                                onChange={(value) => onClaimNumberChange(value)}
                                nullable={true}    
                                nullableItem={ {itemID:null, name:""}}            
                              /> */}
                            </div>
                          </td>
                      </tr>                                
                  </tbody>
              </table>
          </div>}
            
            {calculationState.package && <div>
              <div className="col s1of3"></div>
              <div className="col s2of3">
                <CalculatorTerm data={calculationState.package} onCalculationClick={onCalculationClick}/>                
              </div>            
              <div className="col s1of1 text-right">  
                <button className="text-14 link-button file-xml" onClick={exportCalculationData}>Export calculation package</button>                                 
              </div>
              <div className="col s1of1">            
              <Tabs selectedIndex={mainTabSelected} onSelect={ (index) => setMainTabSelected(index) }>
                  <TabList>
                  <Tab>Stillingar</Tab>                
                  {calculationState.package && calculationState.package.isBond && <Tab>Stillingar skuldabréf</Tab>}
                  <Tab>Niðurstaða</Tab>                
                  <Tab>Ráðstöfun</Tab>                
                  </TabList>                  
                  <TabPanel> <SettingsTab data={calculationState.package}/> </TabPanel>                
                  {calculationState.package && calculationState.package.isBond && <TabPanel><BondTab data={calculationState.package}/></TabPanel>}
                  <TabPanel> <ResultTab data={calculationState.result}/> </TabPanel>                
                  <TabPanel> <AllocateTab data={calculationState.result}/> </TabPanel>                
              </Tabs>
            </div>
           </div>}
        </div>     

  </div>
  );
};
